import { useTranslate } from "@refinedev/core";

export const useSectorOptions = () => {
  const translate = useTranslate();

  const getSectorOptions = () => [
    { value: "", label: translate("options.none") },
    { value: 1, label: translate("options.sectors.1") },
    { value: 2, label: translate("options.sectors.2") }
  ];

  return { getSectorOptions };
};
